import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/app/karriere/components/KarriereInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/components/Header.tsx");
